module.exports = __webpack_public_path__ + "img/6A8287_405153_839EBE_424C5C-256px.a27d265d.png";